import { Dialog, DialogTitle, Tooltip } from '@efexteam/components';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Box, DialogContent, Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ObtainLinkStyles from './ObtainLink.styles';
import { ObtainLinkProps } from './ObtainLink.types';

const TOOLTIP_OPEN_TIME = 1000;

const ObtainLink = ({ isOpen, onClose, link }: ObtainLinkProps) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const { t } = useTranslation();

  const handleCopyLink = () => {
    navigator.clipboard.writeText(link);
    setTooltipOpen(true);

    setTimeout(() => {
      setTooltipOpen(false);
    }, TOOLTIP_OPEN_TIME);
  };

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle
        className={ObtainLinkStyles.title}
        showCloseButton
        onClick={onClose}
      />

      <DialogContent className={ObtainLinkStyles.textContainer}>
        <Typography variant="h6">
          {t('onbLifeProofVerificationLinkTitle')}
        </Typography>
        <Typography variant="body2">
          {t('onbLifeProofVerificationLinkDescription')}
        </Typography>
        <Box
          onClick={handleCopyLink}
          className={ObtainLinkStyles.linkContainer}
        >
          <Typography variant="body2">{link}</Typography>

          <Tooltip
            arrow
            disableFocusListener
            disableHoverListener
            disableTouchListener
            open={tooltipOpen}
            placement="top"
            title={t('onbLifeProofVerificationLinkTooltip')}
          >
            <ContentCopyIcon />
          </Tooltip>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ObtainLink;
